import { useRestClient } from '@/contexts/QueryProvider'
import { useGetSearchParam } from '@/hooks'
// import { useSuspenseQuery } from '@tanstack/react-query'
// import { menuData } from '@/unity-apps/mock-data/menu.json'
// import { json } from '@/catalog-apps/mock-data/app-menu/app-menu.json'

export function useGetAppMenu() {
  const { getLandingApiGetPlatformOperations } = useRestClient()
  const appId = useGetSearchParam<number>('appId')
  const projectId = useGetSearchParam<number>('projectId')
  return getLandingApiGetPlatformOperations.useSuspenseQuery(
    { query: { appId, projectId, grouping: 'menu' } }
    // {
    //   select: () => json,
    // }
  )
}
